// extracted by mini-css-extract-plugin
export var animatedSpinnerContainer = "contact-us-module--animated-spinner-container--25b5b";
export var animatedSpinnerContainerOther = "contact-us-module--animated-spinner-container-other--ae563";
export var disabledSupportOption = "contact-us-module--disabled-support-option--a8def";
export var heading = "contact-us-module--heading--97594";
export var inlineAlertContainer = "contact-us-module--inline-alert-container--9c56b";
export var innerContainer = "contact-us-module--inner-container--112b0";
export var innerContentContainerLeft = "contact-us-module--inner-content-container-left--f4ea3";
export var innerContentContainerRight = "contact-us-module--inner-content-container-right--6d71f";
export var invisibleLoginComponent = "contact-us-module--invisible-login-component--d5ed2";
export var loginLoaderContainer = "contact-us-module--loginLoaderContainer--52966";
export var supportOptions = "contact-us-module--support-options--bd8e3";
export var visibleLoginComponent = "contact-us-module--visible-login-component--9dfaa";